import styled, { css } from 'styled-components';
import { media, layout } from '@prisjakt/ui-base';
import CloseIconBase from 'mdi-react/CloseIcon';
import { OutlinedButton } from '@prisjakt/ui/button/variants';

const headerSearchMaxwidthDesktop = '360px';
const inlineSearchMaxwidthDesktop = '326px';

type ProductFinderProps = {
  showSearchInHeader: boolean;
};

export const ProductFinderWrapper = styled.div<ProductFinderProps>(
  props => css`
    width: 100%;
    display: flex;
    flex-direction: row;

    ${media.mediumDown`
      width: 100%;
      align-items: center;
    `};

    ${media.largeUp`
      min-width: ${!props.showSearchInHeader && inlineSearchMaxwidthDesktop};
      width: ${!props.showSearchInHeader && inlineSearchMaxwidthDesktop};
      padding-right: ${!props.showSearchInHeader && '10px'};
    `}
  `
);

export const ProductFinder = styled.div<ProductFinderProps>(
  props => css`
    position: relative;
    display: flex;
    flex-direction: row;
    border-radius: 7px;
    width: 100%;

    > div {
      width: 100%;
    }

    ${media.largeUp`
      width: ${props.showSearchInHeader && headerSearchMaxwidthDesktop};
    `};
  `
);

export const CloseSearchButton = styled(OutlinedButton)(() => {
  const size =
    layout.searchBar.height.mobile.value + layout.searchBar.borderWidth * 2;

  return css`
    z-index: 4;
    margin-left: 0;
    left: calc(-1 * ${layout.measurements.spacing050});
    height: ${size}px;
    width: ${size}px;
  `;
});

export const CloseIcon = styled(CloseIconBase)``;
